// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1us90","label":"Completed_label__2B8kJ"};